import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getColorAll = (_params, onSuccess, onError) => {
    // _params.orders = 'name:asc';
    const response = axios.get('v1/admin/color', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getColorById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/color/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createColor = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/color`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateColor = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/color/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteColor = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/color/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteColor = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/color/${id}`);
    return handleResponse(response, onSuccess, onError);
};